module.exports = __webpack_public_path__ + "static/media/tablet-front.fc391864.jpg";